var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { isErrorHTTP, isSuccessHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { router } from '../router/BoostPortalRouter';
import { BoostButton } from './common/BoostButton';
import { BoostStatusContainer } from './common/BoostStatusContainer';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { BoostMetoderTilgjengeligEtterInnloggAPI } from 'boost-api/boost/signup/boost_metoder_tilgjengelig_etter_innlogg/BoostMetoderTilgjengeligEtterInnloggAPI';
import { BoostDatePicker } from './common/BoostDatePicker';
import { Checkbox } from '@vaadin/checkbox';
import { CheckboxGroup } from '@vaadin/checkbox-group';
import { EmailField } from '@vaadin/email-field';
import { NumberField } from '@vaadin/number-field';
import { RadioGroup } from '@vaadin/radio-group';
import { RadioButton } from '@vaadin/radio-group/vaadin-radio-button';
import { TextField } from '@vaadin/text-field';
import { CerumFormBuilder } from 'cerumx-shared/CerumFormBuilder';
import moment from 'moment';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
import { CerumItemTagType } from 'cerumx-shared/CerumItemTag';
import { BoostPortalBirthdayHelper } from '../helpers/BoostPortalBirthdayHelper';
import { ewNewMemberInfoResult } from 'boost-api/schemas/ewNewMemberInfoResult';
let BoostPortalPersonalInformation = class BoostPortalPersonalInformation extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    static get is() {
        return 'boost-portal-personal-information';
    }
    static get styles() {
        return css `
            .flex {
                display: flex;
                flex-wrap: wrap;
                margin-top: 20px;
            }

            .flex div {
                flex: 1;
                flex-direction: row;
            }

            .flex div:first-child {
                margin-right: 10px;
            }

            .lookup {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                flex-direction: row;
                width: 100%;
            }

            .lookup-margin {
                margin-right: 20px;
                flex: 1;
            }

            vaadin-text-field,
            vaadin-number-field,
            vaadin-email-field {
                width: 100%;
                padding-bottom: 15px;
            }

            .full-width {
                width: 100%;
            }

            h4 {
                color: var(--boost-font-color-dark);
                font-weight: 500;
                margin-bottom: 10px;
                margin-top: 0;
            }

            a:link,
            a:visited,
            a:active {
                text-decoration: underline;
                color: var(--portalLink, #2a9ba3);
            }

            a:hover {
                text-decoration: none;
            }

            .summary-textbox {
                display: flex;
                margin-top: 10px;
                padding: 1rem;
                background-color: white;
                border-radius: 6px;
                color: #111;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
                align-items: center;
                gap: 6px;
                flex-direction: column;
            }

            .not-validated-fields {
                display: flex;
                color: red;
                flex-direction: column;
                gap: 6px;
                flex-flow: wrap;
                padding-top: 6px;
            }

            #sponsor-text {
                width: 70%;
                align-self: center;
                margin-right: 20px;
                font-size: 16px;
                color: #ff4040;
            }

            #i-sponsor-text {
                font-weight: bold;
                margin: 0px;
                font-size: 18px;
            }

            vaadin-text-field[id='municipality'] > input:disabled {
                --lumo-disabled-text-color: #656565;
            }

            cerum-loading {
                --loading-container-width: 100%;
            }

            .phone-lookup-container {
                display: flex;
                width: 60%;
            }

            @media only screen and (max-width: 600px) {
                .flex {
                    flex-direction: column;
                }

                .flex div:first-child {
                    margin-right: 0px;
                }

                .lookup {
                    width: 100%;
                    flex-direction: column;
                }

                .lookup-margin {
                    margin-right: 0px;
                    flex: 0;
                }
                .full-width {
                    width: 100%;
                    min-width: 100%;
                }
                vaadin-text-field,
                vaadin-number-field,
                vaadin-email-field,
                vaadin-checkbox {
                    width: 100%;
                    padding-bottom: 10px;
                }

                .summary-textbox {
                    flex-direction: column;
                }

                #sponsor-text {
                    width: 100%;
                    margin: 0;
                }

                #i-sponsor-text {
                    font-weight: bold;
                    margin: 0px;
                    font-size: 16px;
                }

                .phone-lookup-container {
                    width: 100%;
                }
            }
        `;
    }
    constructor() {
        super();
        this.memberExists = false;
        this.memberIsUnderaged = false;
        this.hideApproval = false;
        this.departments = [];
        this.isUnknownAreaCode = false;
        this.meetsMinimumAge = true;
        this.meetsShortTermMinimumAge = true;
        this.memberLoggedIn = false;
        this.hideSummaryBox = false;
        this.formBuilder = new CerumFormBuilder(this);
        this.localMemberInfo = new ewNewMemberInfoResult();
        this.birthdayHelper = new BoostPortalBirthdayHelper();
        this.updateComplete.then(() => {
            window.addEventListener('validateFields', this.validateFields.bind(this));
        });
    }
    /** @override */ render() {
        var _a, _b, _c, _d;
        return html `
            ${!this.session
            ? html ` <div class="lookup" style="justify-content:end">
                      ${this.isSponsor
                ? html `
                                ${this.sponsoredMember
                    ? html `<span style="width:50%; margin-top:15px;margin-right:80px">
                                          ${this.boostTranslateOutputHtml('sponsor-for-member-info', {
                        firstName: this.sponsoredMember.firstname,
                        lastName: this.sponsoredMember.lastname,
                    })}
                                      </span>`
                    : html `<span id="sponsor-text">
                                          <i id="i-sponsor-text">OBS!</i><br />
                                          ${this.boostTranslate('sponsor-for-member-description')}
                                      </span>`}
                            `
                : html ``}
                      <div>
                          <div class="phone-lookup-container">
                              <vaadin-text-field
                                  pattern="^[0-9]{8,}$"
                                  allowed-char-pattern="[0-9]"
                                  label="${this.boostTranslate('phonenumber')}"
                                  value="${(this.loggedInProfile && this.loggedInProfile.mobil) || ''}"
                                  @value-changed="${(event) => this._lookupNumber(event)}"
                                  @keydown="${(event) => this._onPhoneKeydown(event)}"
                              ></vaadin-text-field>

                              <boost-button
                                  id="lookUpButton"
                                  style="padding-top:37px; font-size:86%;"
                                  type="header-button"
                                  name="${this.boostTranslate('search')}"
                                  ?disabled="${(this.memberInformation &&
                !this.memberInformation.phone_number) ||
                false}"
                                  @click="${this._personalInfoLookup}"
                              ></boost-button>
                          </div>
                          ${this.memberExists
                ? html `
                                    <boost-status-container type="info">
                                        ${this.boostTranslateOutputHtml('welcome-back', {
                    url: router.baseUrl + this.centerShort + '/login',
                })}
                                    </boost-status-container>
                                `
                : html ``}
                      </div>
                  </div>`
            : nothing}
            <div class="flex">
                <div>
                    <vaadin-text-field
                        ${this.formBuilder.setValidation('firstname')}
                        placeholder="${this.boostTranslate('first-name')}"
                        value="${this._getUserFirstName() || ''}"
                        @value-changed="${(event) => this._setFirstName(event)}"
                        required
                        ?disabled="${this.session !== undefined || false}"
                    ></vaadin-text-field>
                </div>

                <div>
                    <vaadin-text-field
                        ${this.formBuilder.setValidation('surname')}
                        placeholder="${this.boostTranslate('surname')}"
                        value="${this._getUserLastName() || ''}"
                        @value-changed="${(event) => this._setLastName(event)}"
                        required
                        ?disabled="${this.session !== undefined || false}"
                    ></vaadin-text-field>
                </div>
            </div>

            <div>
                <vaadin-text-field
                    ${this.formBuilder.setValidation('address')}
                    placeholder="${this.boostTranslate('address')}"
                    value="${this._getUserAddress() || ''}"
                    @value-changed="${(event) => this._setPostalAddress(event)}"
                    required
                ></vaadin-text-field>
            </div>

            <div class="flex">
                <div>
                    <vaadin-text-field
                        ${this.formBuilder.setValidation('postal')}
                        prevent-invalid-input
                        allowed-char-pattern="[0-9]"
                        maxlength="4"
                        placeholder="${this.boostTranslate('postal-code')}"
                        value="${this._getUserPostalCode() || ''}"
                        @value-changed="${(event) => this._setPostalCode(event)}"
                        required
                    ></vaadin-text-field>
                </div>

                <div>
                    <vaadin-text-field
                        ${this.formBuilder.setValidation('municipality')}
                        placeholder="${this.boostTranslate('municipality')}"
                        value="${this._getUserMunicipality()}"
                        @value-changed="${(event) => this._setMunicipality(event)}"
                        required
                    ></vaadin-text-field>
                </div>
            </div>

            <div class="flex">
                <div>
                    <vaadin-text-field
                        ${this.formBuilder.setValidation('telephone')}
                        prevent-invalid-input
                        pattern="[0-9]{8}"
                        allowed-char-pattern="[0-9]"
                        helper-text="Foreign phone number? Format: 0046123456789"
                        placeholder="${this.boostTranslate('phonenumber')}"
                        value="${this._getUserPhoneNumber() || ''}"
                        @value-changed="${(event) => this._setPhoneNumber(event)}"
                        required
                        ?disabled="${this.session !== undefined || false}"
                    ></vaadin-text-field>
                </div>

                <div>
                    <vaadin-email-field
                        ${this.formBuilder.setValidation('email')}
                        placeholder="${this.boostTranslate('email')}"
                        value="${this._getUserEmail() || ''}"
                        @value-changed="${(event) => this._setMail(event)}"
                        required
                    ></vaadin-email-field>
                </div>
            </div>

            <div class="flex">
                <boost-date-picker
                    ${this.formBuilder.setValidation('birthday')}
                    .date="${this._getBirthdayDate()}"
                    @date-changed="${(event) => this._setMemberBirthday(event)}"
                    ?disabled="${this.session ? true : false}"
                ></boost-date-picker>

                <vaadin-radio-group
                    ${this.formBuilder.setValidation('gender')}
                    label="${this.boostTranslate('gender')}"
                    value="${(_a = this._getUserGender()) !== null && _a !== void 0 ? _a : ''}"
                    @value-changed="${(event) => this._setGender(event)}"
                    required
                >
                    <vaadin-radio-button
                        value="mann"
                        label="${this.boostTranslate('male')}"
                    ></vaadin-radio-button>

                    <vaadin-radio-button
                        value="kvinne"
                        label="${this.boostTranslate('female')}"
                    ></vaadin-radio-button>
                </vaadin-radio-group>
            </div>
            ${!this.hideApproval
            ? html `<div class="flex" style="margin-top: 10px;"></div> 
                    ${this.memberLoggedIn
                ? nothing
                : html `<div class="flex" style="margin-top: 10px; margin-bottom:10px;">
                                  <vaadin-checkbox-group
                                      label="${this.boostTranslate('terms-of-agreement')}"
                                      required
                                      ${this.formBuilder.setValidation('approve_tos')}
                                  >
                                      <vaadin-checkbox
                                          @checked-changed="${(event) => this._setTermsOfApproval(event.detail.value)}"
                                          ?checked="${(_c = (_b = this.memberInformation) === null || _b === void 0 ? void 0 : _b.approve_tos) !== null && _c !== void 0 ? _c : (_d = this.sponsoredMember) === null || _d === void 0 ? void 0 : _d.approve_tos}"
                                          style="width:auto"
                                      ></vaadin-checkbox>
                                      <div style="display:flex; gap:4px ">
                                          <span
                                              >${this.boostTranslateOutputHtml('confirmed-terms-of-agreement', {
                    terms: this._getTermsOfServiceUrl(),
                })}
                                          </span>
                                      </div>
                                  </vaadin-checkbox-group>
                              </div>`} 
                    ${!this.memberLoggedIn && !this.hideSummaryBox ? this._renderSummaryBox() : html ``}   
                    ${this.formBuilder.invalidFields.length
                ? this._renderNotValidatedFields(this.formBuilder.invalidFields)
                : ''}
                      </div>
                  </div> 
               `
            : nothing}
        `;
    }
    _renderSummaryBox() {
        const membership = this.getMembershipById();
        const department = this.getDepartmentById();
        const price = String(membership === null || membership === void 0 ? void 0 : membership.cost_included_vat).replace('.', ',');
        return html `<span style="color:#63666a;">${this.boostTranslate('your-choice')} </span>
            <div class="summary-container">
                <div class="summary-textbox">
                    <span style="font-size: 18px;"
                        >${this.boostTranslate('membership')} ${membership === null || membership === void 0 ? void 0 : membership.title}
                    </span>
                    <span style="font-size: 14px;">${department === null || department === void 0 ? void 0 : department.navn} </span>

                    <span style="font-size: 18px;">
                        kr
                        ${!(membership === null || membership === void 0 ? void 0 : membership.temporary)
            ? html `${price + ' '}
                                  <span style="font-size: 14px;">${this.boostTranslate('per-month')} </span>`
            : price}
                    </span>
                </div>
            </div>`;
    }
    _onPhoneKeydown(event) {
        if (event.code === 'Enter') {
            this._personalInfoLookup();
        }
    }
    _setTermsOfApproval(value) {
        this._setMemberInformation('approve_tos', value);
    }
    _setGender(event) {
        this._setMemberInformation('gender', event.detail.value);
    }
    _setMail(event) {
        this._setMemberInformation('email', event.detail.value.toLowerCase());
    }
    _setPhoneNumber(event) {
        if (!this.memberInformation) {
            return;
        }
        this._setMemberInformation('phone_number', event.detail.value);
        this.dispatchEvent(new CustomEvent('memberPhoneNumber-changed', {
            detail: {
                memberPhoneNumber: this.memberInformation.phone_number,
            },
            bubbles: true,
            composed: true,
        }));
    }
    _setMunicipality(event) {
        this._setMemberInformation('municipality', event.detail.value);
    }
    _setPostalCode(event) {
        if (event.detail.value.length !== 4) {
            return;
        }
        this._setMemberInformation('postal_code', event.detail.value);
        this._lookupMunicipality(event.detail.value);
    }
    _setPostalAddress(event) {
        this._setMemberInformation('address', this._capitalizeWordBoundary(event.detail.value));
    }
    _setLastName(event) {
        this._setMemberInformation('lastname', this._capitalizeWordBoundary(event.detail.value));
    }
    _setFirstName(event) {
        this._setMemberInformation('firstname', this._capitalizeWordBoundary(event.detail.value));
    }
    _lookupNumber(event) {
        this._setMemberInformation('phone_number', event.detail.value);
    }
    _setMemberBirthday(event) {
        var _a, _b;
        const datePickerDate = event.detail.value;
        if (!datePickerDate.date || !datePickerDate.month || !datePickerDate.year) {
            return;
        }
        const selectedDate = moment([datePickerDate.year, datePickerDate.month - 1, datePickerDate.date]);
        this._setMemberInformation('date_of_birth', selectedDate.format('YYYY-MM-DD'));
        this.meetsMinimumAge = this.birthdayHelper.memberMeetsMinimumAge(selectedDate.toISOString(), (_a = this.center) === null || _a === void 0 ? void 0 : _a.minimum_age);
        this.meetsShortTermMinimumAge = this.birthdayHelper.memberMeetsShortTermMinimumAge(selectedDate.toISOString(), (_b = this.center) === null || _b === void 0 ? void 0 : _b.short_term_minimum_age);
        this.memberIsUnderaged = this.birthdayHelper.isMemberUnderage(selectedDate.toISOString());
    }
    _renderNotValidatedFields(invalidFields) {
        return html `
            <div style="padding-top: 20px;">
                <cerum-form-label>${this.boostTranslate('missing-fields')}</cerum-form-label>
                <div class="not-validated-fields">
                    ${invalidFields.map((field) => {
            var _a;
            return html `<cerum-item-tag
                            style="--item-tag-font-size: 14px;"
                            itemType="${CerumItemTagType.ERROR}"
                            >${(_a = field.invalidTitle) !== null && _a !== void 0 ? _a : field.id}</cerum-item-tag
                        >`;
        })}
                </div>
            </div>
        `;
    }
    getDepartmentById() {
        return this.departments.find((department) => department.id === this.selectedDepartmentId);
    }
    getMembershipById() {
        var _a;
        return (_a = this.memberships) === null || _a === void 0 ? void 0 : _a.find((membership) => membership.id === this.selectedMembershipId);
    }
    _sessionObserver() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.session) {
                return;
            }
            const profileResult = yield BoostMetoderTilgjengeligEtterInnloggAPI.getExerciseProfile({
                session: this.session,
            });
            if (isSuccessHTTP(profileResult)) {
                this.dispatch(BoostPortalStore.Actions.SetLoggedInProfile(profileResult));
            }
            else if (isErrorHTTP(profileResult)) {
                SnackBar.pushError(profileResult.error);
            }
        });
    }
    _getTermsOfServiceUrl() {
        if (!this.center || !this.selectedDepartmentId) {
            return '#';
        }
        const termsOfService = this.center.link_to_tos.find((terms) => terms.id === this.selectedDepartmentId);
        if (!termsOfService || !termsOfService.url) {
            return '#';
        }
        return termsOfService.url;
    }
    _getUserFirstName() {
        if (this.loggedInProfile && this.loggedInProfile.fornavn) {
            return this.loggedInProfile.fornavn;
        }
        if (this.memberInformation && this.memberInformation.firstname) {
            return this.memberInformation.firstname;
        }
    }
    _getUserLastName() {
        if (this.loggedInProfile && this.loggedInProfile.etternavn) {
            return this.loggedInProfile.etternavn;
        }
        if (this.memberInformation && this.memberInformation.lastname) {
            return this.memberInformation.lastname;
        }
    }
    _getUserGender() {
        if (this.loggedInProfile && this.loggedInProfile.kjonn) {
            return this.loggedInProfile.kjonn === 1 ? 'mann' : 'kvinne';
        }
        if (this.memberInformation && this.memberInformation.gender) {
            return this.memberInformation.gender;
        }
    }
    _getUserAddress() {
        if (this.loggedInProfile && this.loggedInProfile.adresse) {
            return this.loggedInProfile.adresse;
        }
        if (this.memberInformation && this.memberInformation.address) {
            return this.memberInformation.address;
        }
    }
    _getUserPostalCode() {
        if (this.loggedInProfile && this.loggedInProfile.postnr) {
            return this.loggedInProfile.postnr;
        }
        if (this.memberInformation && this.memberInformation.postal_code) {
            return this.memberInformation.postal_code;
        }
    }
    _getUserMunicipality() {
        if (this.isUnknownAreaCode) {
            return this.boostTranslate('unknown-postal-code');
        }
        if (this.loggedInProfile && this.loggedInProfile.poststed) {
            return this.loggedInProfile.poststed;
        }
        if (this.memberInformation && this.memberInformation.municipality) {
            return this.memberInformation.municipality;
        }
        return '';
    }
    _getUserPhoneNumber() {
        if (this.loggedInProfile && this.loggedInProfile.mobil) {
            return this.loggedInProfile.mobil;
        }
        if (this.memberInformation && this.memberInformation.phone_number) {
            return this.memberInformation.phone_number;
        }
    }
    _getUserEmail() {
        if (this.loggedInProfile && this.loggedInProfile.epost) {
            return this.loggedInProfile.epost;
        }
        if (this.memberInformation && this.memberInformation.email) {
            return this.memberInformation.email;
        }
    }
    _capitalizeWordBoundary(name) {
        return name.replace(/(^|\s)\S/g, (replacedName) => replacedName.toUpperCase());
    }
    _getTodaysDate() {
        const dateObj = new Date();
        const date = dateObj.getDate();
        const month = dateObj.getMonth() + 1;
        const year = dateObj.getFullYear();
        return year + '-' + month + '-' + date;
    }
    _lookupMunicipality(postalCode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!postalCode || !postalCode.length) {
                return;
            }
            const municipalityResult = yield MembersignupAPI.getV1BoostsignupLookupMunicipalityUsingAreacode(postalCode);
            if (isErrorHTTP(municipalityResult)) {
                if (municipalityResult.error.message === 'Unknown areacode') {
                    this.isUnknownAreaCode = true;
                }
                this._setMemberInformation('municipality', '');
                return;
            }
            if (municipalityResult.municipality) {
                this.isUnknownAreaCode = false;
                this._setMemberInformation('municipality', municipalityResult.municipality);
            }
        });
    }
    _meetsMinimumAgeObserver() {
        this.dispatchEvent(new CustomEvent('meetsMinimumAge', {
            detail: {
                value: this.meetsMinimumAge,
            },
            bubbles: true,
            composed: true,
        }));
    }
    _meetsShortTermMinimumAgeObserver() {
        this.dispatchEvent(new CustomEvent('meetsShortTermMinimumAge', {
            detail: {
                value: this.meetsShortTermMinimumAge,
            },
            bubbles: true,
            composed: true,
        }));
    }
    _memberIsUnderagedObserver() {
        this.dispatchEvent(new CustomEvent('memberIsUnderaged-changed', {
            detail: {
                memberIsUnderaged: this.memberIsUnderaged,
            },
            bubbles: true,
            composed: true,
        }));
    }
    _personalInfoLookup() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if ((_a = this.lookUpButton) === null || _a === void 0 ? void 0 : _a.disabled) {
                return;
            }
            if (!this.memberInformation || !this.memberInformation.phone_number) {
                return;
            }
            this.memberExists = false;
            (_b = this.lookUpButton) === null || _b === void 0 ? void 0 : _b.setLoading(true);
            const lookupResult = yield MembersignupAPI.getV1BoostsignupLookupPhoneUsingPhonenumber(this.memberInformation.phone_number);
            (_c = this.lookUpButton) === null || _c === void 0 ? void 0 : _c.setLoading(false);
            if (isErrorHTTP(lookupResult)) {
                SnackBar.pushError(lookupResult.error);
                return;
            }
            if ((_d = lookupResult.at(0)) === null || _d === void 0 ? void 0 : _d.exists) {
                this.memberExists = true;
                return;
            }
            if (!lookupResult.length) {
                return;
            }
            const { firstname, lastname, address, postal_code: postalCode, municipality } = lookupResult[0];
            this._setMemberInformation('firstname', firstname);
            this._setMemberInformation('lastname', lastname);
            this._setMemberInformation('address', address);
            this._setMemberInformation('postal_code', postalCode);
            this._setMemberInformation('municipality', municipality);
        });
    }
    validateFields() {
        this.formBuilder.schema = {
            firstname: {
                expect: 'filled',
                errorMessage: this.boostTranslate('missing-first-name'),
                invalidTitle: this.boostTranslate('first-name'),
            },
            surname: {
                expect: 'filled',
                errorMessage: this.boostTranslate('missing-last-name'),
                invalidTitle: this.boostTranslate('surname'),
            },
            address: {
                expect: 'filled',
                errorMessage: this.boostTranslate('missing-address'),
                invalidTitle: this.boostTranslate('address'),
            },
            postal: {
                expect: 'filled',
                errorMessage: this.boostTranslate('missing-postal-code'),
                invalidTitle: this.boostTranslate('postal-code'),
            },
            municipality: { expect: 'filled' },
            telephone: {
                expect: 'filled',
                errorMessage: this.boostTranslate('missing-phonenumber'),
                invalidTitle: this.boostTranslate('phonenumber'),
            },
            email: {
                expect: 'filled',
                errorMessage: this.boostTranslate('missing-email'),
                invalidTitle: this.boostTranslate('email'),
            },
            gender: {
                expect: true,
                errorMessage: this.boostTranslate('missing-gender'),
                invalidTitle: this.boostTranslate('gender'),
            },
            birthday: {
                customValidation: () => {
                    var _a, _b;
                    return [
                        Boolean((_a = this.memberInformation) === null || _a === void 0 ? void 0 : _a.date_of_birth),
                        (_b = this.memberInformation) === null || _b === void 0 ? void 0 : _b.date_of_birth,
                    ];
                },
                invalidTitle: this.boostTranslate('date-of-birth'),
            },
        };
        if (this.loggedInProfile) {
            this.formBuilder.schema['approve_tos'] = {
                expect: true,
                errorMessage: this.boostTranslate('missing-terms-of-agreement'),
                invalidTitle: this.boostTranslate('terms-of-agreement'),
            };
        }
        return this.formBuilder.validate();
    }
    _getBirthdayDate() {
        var _a;
        if (this.loggedInProfile) {
            const birthdayMoment = moment(this.loggedInProfile.birth);
            if (!birthdayMoment.isValid()) {
                return {};
            }
            return {
                date: birthdayMoment.date(),
                month: birthdayMoment.month() + 1,
                year: birthdayMoment.year(),
            };
        }
        else if ((_a = this.memberInformation) === null || _a === void 0 ? void 0 : _a.date_of_birth) {
            const birthdayMoment = moment(this.memberInformation.date_of_birth);
            if (!birthdayMoment.isValid()) {
                return {};
            }
            return {
                date: birthdayMoment.date(),
                month: birthdayMoment.month() + 1,
                year: birthdayMoment.year(),
            };
        }
        return {};
    }
    _municipalityObserver() {
        var _a, _b;
        const municipality = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#municipality');
        if (!this.isUnknownAreaCode && municipality) {
            municipality.invalid = false;
        }
        else if (municipality && ((_b = this.memberInformation) === null || _b === void 0 ? void 0 : _b.postal_code.length) === 4) {
            municipality.invalid = true;
        }
    }
    _setMemberInformation(key, value) {
        this.localMemberInfo = Object.assign(Object.assign({}, this.localMemberInfo), { [key]: value });
        clearTimeout(this.setMemberInformationTimeout);
        this.setMemberInformationTimeout = setTimeout(() => {
            this.dispatch(BoostPortalStore.Actions.SetMemberInformation(this.localMemberInfo));
        }, 200);
    }
    _memberExistsObserver() {
        this.dispatchEvent(new CustomEvent('memberExists-changed', {
            detail: {
                memberExists: this.memberExists,
            },
            bubbles: true,
            composed: true,
        }));
    }
    /** @override */
    updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'memberIsUnderaged':
                    this._memberIsUnderagedObserver();
                    break;
                case 'meetsMinimumAge':
                    this._meetsMinimumAgeObserver();
                    break;
                case 'meetsShortTermMinimumAge':
                    this._meetsShortTermMinimumAgeObserver();
                    break;
                case 'session':
                    this._sessionObserver();
                    break;
                case 'isUnknownAreaCode':
                case 'memberInformation':
                    this._municipalityObserver();
                    break;
                case 'memberExists':
                    this._memberExistsObserver();
                    break;
            }
        });
        super.updated(changedProperties);
    }
};
BoostPortalPersonalInformation._deps = [
    BoostButton,
    BoostStatusContainer,
    BoostDatePicker,
    TextField,
    NumberField,
    EmailField,
    RadioGroup,
    RadioButton,
    CheckboxGroup,
    Checkbox,
];
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalPersonalInformation.prototype, "centerShort", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalPersonalInformation.prototype, "memberExists", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('center')),
    state(),
    __metadata("design:type", Object)
], BoostPortalPersonalInformation.prototype, "center", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberInformation')),
    state(),
    __metadata("design:type", Object)
], BoostPortalPersonalInformation.prototype, "memberInformation", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalPersonalInformation.prototype, "memberIsUnderaged", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalPersonalInformation.prototype, "selectedDepartmentId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedMembershipId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalPersonalInformation.prototype, "selectedMembershipId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('session')),
    state(),
    __metadata("design:type", String)
], BoostPortalPersonalInformation.prototype, "session", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('loggedInProfile')),
    state(),
    __metadata("design:type", Object)
], BoostPortalPersonalInformation.prototype, "loggedInProfile", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalPersonalInformation.prototype, "hideApproval", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalPersonalInformation.prototype, "isSponsor", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], BoostPortalPersonalInformation.prototype, "sponsoredMember", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('departments')),
    state(),
    __metadata("design:type", Array)
], BoostPortalPersonalInformation.prototype, "departments", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberships')),
    state(),
    __metadata("design:type", Array)
], BoostPortalPersonalInformation.prototype, "memberships", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalPersonalInformation.prototype, "isUnknownAreaCode", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalPersonalInformation.prototype, "meetsMinimumAge", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalPersonalInformation.prototype, "meetsShortTermMinimumAge", void 0);
__decorate([
    query('#lookUpButton'),
    __metadata("design:type", BoostButton)
], BoostPortalPersonalInformation.prototype, "lookUpButton", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalPersonalInformation.prototype, "memberLoggedIn", void 0);
__decorate([
    property({ type: Boolean, attribute: 'hide-summary-box' }),
    __metadata("design:type", Boolean)
], BoostPortalPersonalInformation.prototype, "hideSummaryBox", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalPersonalInformation.prototype, "formBuilder", void 0);
__decorate([
    state(),
    __metadata("design:type", void 0)
], BoostPortalPersonalInformation.prototype, "setMemberInformationTimeout", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalPersonalInformation.prototype, "localMemberInfo", void 0);
BoostPortalPersonalInformation = __decorate([
    customElement(BoostPortalPersonalInformation.is),
    __metadata("design:paramtypes", [])
], BoostPortalPersonalInformation);
export { BoostPortalPersonalInformation };
